"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.235 3.559a.5.5 0 0 0-.47 0l-7.5 4A.5.5 0 0 0 4 8v8a.5.5 0 0 0 .243.429l7.5 4.5a.5.5 0 0 0 .514 0l7.5-4.5A.5.5 0 0 0 20 16V8a.5.5 0 0 0-.265-.441zM11.5 12.3v7.317l-6.5-3.9V8.833zm7.5 3.417-6.5 3.9V12.3L19 8.833zM18.438 8 12 11.433 5.563 8 12 4.567z"
}), 'Box');
//# sourceMappingURL=index.js.map